import React, { useState } from "react";
import { Button, Tooltip, IconButton, Box } from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import copy from "copy-to-clipboard";

interface IProps {
  value: string | number;
  useIcon?: boolean;
}

const CopyToClipboard = ({ value, useIcon }: IProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const handleTooltipCpyClose = () => setOpen(false);
  const handleTooltipCopyOpen = () => {
    setOpen(true);
    copy(value.toString());
  };

  return (
    <Box position="relative" onMouseLeave={handleTooltipCpyClose}>
      <Tooltip
        PopperProps={{
          disablePortal: true,
        }}
        open={open}
        title="Copied"
      >
        {useIcon ? (
          <IconButton onClick={handleTooltipCopyOpen}>
            <FileCopyIcon />
          </IconButton>
        ) : (
          <Button
            variant="text"
            onClick={handleTooltipCopyOpen}
            sx={{
              padding: "0 3px",
              textTransform: "none",
              fontWeight: 400,
              fontSize: "15px",
              minWidth: "auto",
              lineHeight: "13px",
              color: "#000",
            }}
          >
            {value}
          </Button>
        )}
      </Tooltip>
    </Box>
  );
};

export default CopyToClipboard;
